import { page } from '$app/state';

import { useNavigationState } from './use-navigation-state.svelte';

export const withQueryParams: (
  href: string,
  queryParams: Record<string, string>,
  hashParam?: string
) => string = (href, queryParams, hashParam) => {
  const queryParamsString = new URLSearchParams(queryParams).toString();
  return `${href}${queryParamsString ? `?${queryParamsString}` : ''}${hashParam ? `#${hashParam}` : ''}`;
};

export const withGlobalQueryParams = (href: string): { url: string } => {
  const navigationState = useNavigationState();

  const url = $derived.by(() => {
    if (!href) {
      return '';
    }
    const pageOrigin = page.url.origin;
    const origin = pageOrigin === 'null' ? 'https://localhost' : pageOrigin;
    const isHash = href.startsWith('#');
    const isRelative = href.startsWith('/') || isHash;
    const hrefOrigin = isRelative ? origin : new URL(href).origin;
    const isInternal = hrefOrigin === origin;
    if (!isInternal) {
      return href;
    }
    const hrefUrl = new URL(href, origin);
    const hrefSearchParams = new URLSearchParams(hrefUrl.search);
    for (const [key, value] of Object.entries(
      navigationState.globalQueryParams
    )) {
      if (!hrefSearchParams.has(key)) {
        hrefSearchParams.set(key, value);
      }
    }
    hrefUrl.search = hrefSearchParams.toString();
    return `${isRelative ? '' : origin}${isHash ? '' : hrefUrl.pathname}${hrefUrl.search}${hrefUrl.hash}`;
  });

  return {
    get url() {
      return url;
    },
  };
};
